import React, { useCallback, useContext } from 'react'
import { Link } from 'gatsby'
import Html from '../Html'
import { SearchContext } from '../../contexts/searchContext'
import { SideMenuContext } from '../../contexts/sideMenuContext'
import * as PathHelpers from '../../helpers/path'
import styles from './styles.module.css'

function SearchResultVersionItem({ slug, hash, title, description }) {
  const { setIsVisible, setIsSearchMobileActive } = useContext(SearchContext)
  const { setSubmenu } = useContext(SideMenuContext)

  const onClick = useCallback(() => {
    const { category } = PathHelpers.getDataByPath(slug)

    setSubmenu(category || null)
    setIsVisible(false)
    setIsSearchMobileActive(false)
  }, [setIsVisible, setSubmenu, setIsSearchMobileActive, slug])

  return (
    <li>
      <Link to={`${slug}#${hash}`} onClick={onClick}>
        <span>{title}</span>
        <div className={styles.searchResultListDescription}>
          <Html as="p">{description}</Html>
        </div>
      </Link>
    </li>
  )
}

export default SearchResultVersionItem
